<template>
  <div>
    <v-row>
      <v-col cols="12" sm="12" class="text-left">
        <v-tooltip bottom v-if="updateMeetingPermission">
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              v-bind="attrs"
              v-on="on"
              color="primaryDark mr-2"
              @click.stop="addNewAttendees()"
            >
              {{ $t("lblAddAttendees") }}
            </a-btn>
          </template>
          <span>{{ $t("lblAddAttendees") }}</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row v-if="updateMeetingPermission">
      <v-divider></v-divider>
    </v-row>
    <v-row v-if="!attendees.length">
      <div
        class="mx-3 my-4 body-m"
        v-if="updateMeetingPermission"
        :key="render"
        @click="openAttndees($event)"
        v-html="
          $t('agenda.msgNoSelectedAttendee', {
            addAttendee: $t('lblAddAttendees'),
          })
        "
      ></div>
      <div class="mx-3 mb-4 body-m" v-else>
        {{ $t("agenda.msgIfNoPemissionNoAttendee") }}
      </div>
    </v-row>
    <v-row
      v-for="(attendee, index) in attendees"
      :key="index"
      class="align-center"
      id="attendanceList"
    >
      <v-col cols="12" sm="4">
        <v-list-item color="primary">
          <v-list-item-avatar size="32">
            <v-img
              contain
              v-if="attendee.profilePhoto"
              :src="attendee.profilePhoto"
            ></v-img>
            <v-img contain v-else src="@/assets/images/NoPhotoIcon.png"></v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="label-m" v-if="attendee.firstName">{{
              attendee.firstName + " " + attendee.lastName
            }}</v-list-item-title>
            <v-list-item-title class="label-m" v-else>{{
              attendee.email
            }}</v-list-item-title>
            <v-list-item-subtitle v-if="attendee.title" class="label-s">{{
              attendee.title
            }}</v-list-item-subtitle>
            <v-list-item-subtitle v-if="attendee.firstName" class="caption">{{
              attendee.email
            }}</v-list-item-subtitle>
            <v-list-item-subtitle
              class="caption mt-1"
              v-if="attendee.emailList && attendee.emailList.length > 0"
            >
              <p
                v-for="alternate in attendee.emailList"
                :key="`alt-email-${alternate}`"
                class="mb-1"
              >
                {{ alternate }}
              </p>
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-icon v-if="!attendee.is_authorized && !isMeetingModified">
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs"
                  v-on="on">mdi-information-outline</v-icon>
                </template>
                <span>{{ $t("tooltipAttendeePermission") }}</span>
              </v-tooltip>
          </v-list-item-icon>
        </v-list-item>
      </v-col>
      <v-col cols="12" sm="4">
        <attendance-btn
          :attendee="attendee"
          :meetingObject="meetingObject"
          :isMeetingModified="isMeetingModified"
        ></attendance-btn>
      </v-col>
      <v-col cols="12" sm="3" >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <v-textarea
                v-if="attendanceRows > 0"
                :rows="attendanceRows"
                filled
                name="attendeNote"
                :label="$t('agenda.lblNote')"
                :value="editingNotes[attendee.id] !== undefined ? editingNotes[attendee.id] : (attendee.attendeNote || '')"
                dense
                :max="50"
                :maxlength="maxlength"
                :counter="maxlength"
                @input="onNoteInput(attendee, $event)"
                hide-details="auto"
                :disabled="shouldDisableNoteField(attendee)"
                :readonly="shouldDisableNoteField(attendee)"
                no-resize
              ></v-textarea>
            </div>
          </template>
          <span>{{ $t("agenda.lblPleaseFillAttendanceMemo")  }}</span>
        </v-tooltip>

        <v-row class="mt-0" v-if="canEditNote(attendee)">
          <v-col cols="12" sm="12" class="text-right pt-1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <a-btn
                  class="ml-2"
                  x-small
                  color="primaryDark"
                  v-bind="attrs"
                  v-on="on"
                  @click="onSaveNote(attendee)"
                  :disabled="!hasNoteChanged(attendee)"
                >
                  {{ $t("btnSave") }}
                </a-btn>
              </template>
              <span>{{ $t("btnSave") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <a-btn
                  class="ml-2"
                  x-small
                  color="secondary"
                  @click="onDiscardNote(attendee)"
                  v-bind="attrs"
                  v-on="on"
                  :disabled="!hasNoteChanged(attendee)"
                >
                  {{ $t("btnDiscard") }}
                </a-btn>
              </template>
              <span>{{ $t("btnDiscard") }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" sm="1">
        <v-row no-gutters class="justify-end mr-2">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                v-if="updateMeetingPermission"
                v-bind="attrs"
                v-on="on"
                class="arrow-up-thick mb-1"
                x-small
                color="primaryDark"
                width="24"
                min-width="24"
                :disabled="index === 0"
                @click="moveAttendee(attendee, index, 'up')"
              >
                <v-icon size="16" color="#fff"> mdi-arrow-up-thick</v-icon>
              </a-btn>
            </template>
            <span>{{ $t("lblMoveUp") }}</span>
          </v-tooltip>
        </v-row>
        <v-row no-gutters class="justify-end mr-2">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                v-if="updateMeetingPermission"
                v-bind="attrs"
                v-on="on"
                class="arrow-down-thick"
                x-small
                color="primaryDark"
                width="24"
                min-width="24"
                :disabled="index === attendees.length - 1"
                @click="moveAttendee(attendee, index, 'down')"
              >
                <v-icon size="16" color="#fff"> mdi-arrow-down-thick</v-icon>
              </a-btn>
            </template>
            <span>{{ $t("lblMoveDown") }}</span>
          </v-tooltip>
        </v-row>
        <v-row no-gutters class="justify-end mr-2">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                v-bind="attrs"
                v-on="on"
                v-if="updateMeetingPermission"
                x-small
                color="primaryDark"
                width="24"
                min-width="24"
                class="mt-4"
                @click="deleteAttende(attendee)"
              >
                <v-icon size="16" color="#fff"> mdi-delete</v-icon>
              </a-btn>
            </template>
            <span>{{ $t("lblDeleteAttendees") }}</span>
          </v-tooltip>
        </v-row>
      </v-col>
      <v-col cols="12" sm="12" class="pa-0">
        <v-divider v-if="index < attendees.length - 1"></v-divider>
      </v-col>
    </v-row>
    <a-dialog
      v-model="newAttendeesDialog"
      v-if="newAttendeesDialog"
      scrollable
      max-width="800px"
      persistent
    >
      <v-card>
        <v-banner color="primaryLight1" sticky single-line tile>
          <v-toolbar color="primaryLight1">
            <v-icon left>mdi-view-agenda</v-icon>
            <span> {{ $t("agenda.hAttendees") }}</span>
            <v-spacer></v-spacer>
            <CloseIcon @click="newAttendeesDialog = false" />
          </v-toolbar>
        </v-banner>

        <v-card-text>
          <v-container style="padding: 0 !important">
            <v-row>
              <v-col cols="12">
                <meeting-participants
                  :meetingAtteendeelist="attendeesList"
                  @onSelection="onParticipantChanged"
                  :label="`${$t('agenda.lblAttendees')} (${$t(
                    'agenda.lblEmailAddress'
                  )})`"
                ></meeting-participants>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                v-on="on"
                v-bind="attrs"
                color="primaryDark"
                @click="saveAttendees"
                :loading="loading"
                :disabled="btnAssignDisable"
              >
                {{ $t("lblAssign") }}
              </a-btn>
            </template>
            <span> {{ $t("lblAssign") }} </span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                v-on="on"
                v-bind="attrs"
                color="secondary"
                class="ml-2"
                @click="newAttendeesDialog = false"
              >
                {{ $t("widget.close") }}
              </a-btn>
            </template>
            <span> {{ $t("widget.close") }} </span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </a-dialog>
      <MessageSheet
        :showMessage="displayMessage"
        :message="message"
        :messageType="messageType"
        @close="displayMessage = false"
      ></MessageSheet>
    <ConfirmDialog ref="confirm" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import SignalRMixin from "../../mixin/SignalRMixin";
import MeetingParticipantListNew from "./MeetingParticipantListNew.vue";
import MeetingParticipants from "./MeetingParticipants.vue";
import ADialog from "../../wrapper-component/ADialog.vue";
import ABtn from "../../wrapper-component/ABtn.vue";
import AMenu from "../../wrapper-component/AMenu.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import MessageSheet from "@/components/MessageSheet.vue";
import AttendanceBtn from "./AttendanceBtn.vue";
import _ from "lodash";
import { TITLE_LENGTH_1000 } from "../../utils/constant";

export default {
  name: "AttendessPanelCard",
  mixins: [SignalRMixin],
  props: {
    attendeesList: Array,
    meetingObject: Object,
    isMeetingModified: Boolean,
    attendanceRows: Number,
  },
  components: {
    MeetingParticipantListNew,
    MeetingParticipants,
    ADialog,
    ABtn,
    AMenu,
    ConfirmDialog,
    MessageSheet,
    AttendanceBtn,
  },
  data() {
    return {
      render: 0,
      maxlength: TITLE_LENGTH_1000,
      disableTooltip: false,
      attendeesData: [],
      newAttendees: [],
      newAttendeesDialog: false,
      selectedState: null,
      loading: false,
      btnAssignDisable: true,
      originalNotes: new Map(),
      editingNotes: {},
      displayMessage: false,
      message: "",
      messageType: "",
    };
  },
  async mounted() {
    this.getAttendeesList();
    const attendanceNoteTarget = `attendance_note_${this.meetingObject.id}`;
    await this.signalRAttendanceNote(attendanceNoteTarget);
  },
  beforeDestroy() {
    this.$root.$off("refresh-meeting-left");
  },
  computed: {
    ...mapGetters({
      getMeetingTypeId: "meeting/getMeetingTypeId",
    }),
    currentUser() {
      return this.$auth.user
    },
    updateMeetingPermission() {
      if (this.getMeetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.getMeetingTypeId,
          "UpdateMeeting"
        );
      }
      return false;
    },
    attendees: {
      get() {
        return this.attendeesData;
      },
      set(val) {
        this.attendeesData = val;
      },
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
  },
  watch: {
    attendeesList(data) {
      this.getAttendeesList();
    },
  },
  created() {
    this.$root.$off("refresh-meeting-left");
  },
  beforeDestroy() {
    this.$root.$off("refresh-meeting-left");
  },
  methods: {
    ...mapActions({
      addAttendeeNote: "meeting/addAttendeeNote",
    }),
    moveAttendee,
    shouldDisableNoteField(attendee) {
      const isUserAuthorized = attendee.id === this.currentUser.user_id || this.updateMeetingPermission;
      return !isUserAuthorized || this.isMeetingModified;
    },
    canEditNote(attendee) {
      const isUserAuthorized = attendee.id === this.currentUser.user_id || this.updateMeetingPermission;
      return isUserAuthorized && !this.isMeetingModified;
    },
    async signalRAttendanceNote(target) {
      try {
        this.signalConnection.on(target, async (res) => {
          if (res.attendees && Array.isArray(res.attendees)) {
            this.attendeesData = this.attendeesData.map((attendee) => {
              const updatedAttendee = res.attendees.find(
                (item) => item.id === attendee.id
              );
              
              if (updatedAttendee) {
                const isEditingThisNote = this.editingNotes[attendee.id] !== undefined;
                
                if (!isEditingThisNote) {
                  this.originalNotes.set(
                    updatedAttendee.id,
                    updatedAttendee.attendeNote || ''
                  );
                  
                  return {
                    ...attendee,
                    attendeNote: updatedAttendee.attendeNote,
                    attendedState: updatedAttendee.attendedState
                  };
                }
              }
              
              return attendee;
            });
          }
        });
        
        if (
          this.signalConnection.connectionState.toLowerCase() === "disconnected"
        ) {
          this.signalConnection.start().catch();
        }
      } catch (error) {
        console.error('SignalR attendance note error:', error);
      }
    },
    showMessageSheet(message, messageType) {
      this.displayMessage = true;
      this.message = message;
      this.messageType = messageType;
    },
    onNoteInput(attendee, value) {
      if (this.shouldDisableNoteField(attendee)) {
        return;
      }
      
      this.$set(this.editingNotes, attendee.id, value);
    },
    hasNoteChanged(attendee) {
      const currentEditingNote = this.editingNotes[attendee.id];
      const originalNote = this.originalNotes.get(attendee.id) || '';
      
      if (currentEditingNote === undefined) {
        return false;
      }
      
      return currentEditingNote.trim() !== originalNote.trim();
    },
    async onSaveNote(attendee) {
      if (this.shouldDisableNoteField(attendee)) return;

      const updatedNote = (this.editingNotes[attendee.id] || '').trim();

      try {
        const payload = {
          attendee_id: attendee.id,
          attendeNote: updatedNote,
          meeting_id: this.meetingObject.id,
        };

        await this.addAttendeeNote(payload);

        this.originalNotes.set(attendee.id, updatedNote);

        this.$delete(this.editingNotes, attendee.id);

        const index = this.attendeesData.findIndex(a => a.id === attendee.id);
        if (index !== -1) {
          this.attendeesData[index].attendeNote = updatedNote;
        }

        this.showMessageSheet(this.$t('agenda.attendanceNoteMsg'), "success");
      } catch (error) {
        console.error('Error saving attendee note:', error);
      }
    },
    onDiscardNote(attendee) {
      if (this.shouldDisableNoteField(attendee)) {
        return;
      }
      
      const originalNote = this.originalNotes.get(attendee.id) || '';
      
      this.$delete(this.editingNotes, attendee.id);
      
      const attendeeIndex = this.attendeesData.findIndex(a => a.id === attendee.id);
      if (attendeeIndex !== -1) {
        this.attendeesData[attendeeIndex].attendeNote = originalNote;
      }
    },
    openAttndees(event) {
      if (event.target.text == this.$t("lblAddAttendees")) {
        this.addNewAttendees();
      }
      setTimeout(() => {
        this.render++;
      }, 100);
    },
    Collapse() {
      this.$eventHub.$emit("onCollapseClick");
    },
    onMenuActionClick(option) {
      this.attendeesData.forEach((item) => {
        item.attendedState = option.value;
      });
      this.$emit("onAttendedStateChanged", this.attendeesData);
    },
    addNewAttendees() {
      this.btnAssignDisable = true;
      this.newAttendeesDialog = true;
    },
    async deleteAttende(attendee) {
      if (
        await this.$refs.confirm.open(
          this.$t("agenda.hDeleteMessage"),
          this.$t("agenda.lblDeleteMessage")
        )
      ) {
        this.attendeesData = this.attendeesData.filter(
          (obj) => obj.id !== attendee.id
        );
        this.$emit("onAttendedStateChanged", this.attendeesData);
        this.$emit("removeAttendees", attendee);
      }
    },
    onParticipantChanged(attendees) {
      const extractAttendees = (attendeeList) =>
        attendeeList
          .map((item) => {
            return {
              id: item.id,
              email: item.email,
              emailList: item.emailList ? item.emailList : [],
            };
          })
          .sort((a, b) => a.email.localeCompare(b.email)) || [];

      const originalMeetingAttendees = extractAttendees(this.attendeesList);
      const assignAttendees = extractAttendees(attendees);
      if (
        JSON.stringify(originalMeetingAttendees) ===
        JSON.stringify(assignAttendees)
      ) {
        this.btnAssignDisable = true;
      } else {
        this.btnAssignDisable = false;
      }
      this.newAttendees = attendees;
    },
    async saveAttendees() {
      this.loading = true;
      const _this = this;
      
      const existingAttendeesMap = new Map();
      this.attendeesData.forEach(attendee => {
        existingAttendeesMap.set(attendee.id, {
          attendeNote: attendee.attendeNote,
          attendedState: attendee.attendedState
        });
      });
      
      const mergeAttendee = [];
      
      this.newAttendees.forEach((item) => {
        const existingData = existingAttendeesMap.get(item.id);
        
        if (_this.selectedState) {
          item.attendedState = _this.selectedState;
        } else if (existingData) {
          item.attendedState = existingData.attendedState;
        }
        
        if (existingData && existingData.attendeNote) {
          item.attendeNote = existingData.attendeNote;
        } else if (!item.attendeNote) {
          item.attendeNote = '';
        }
        
        _this.originalNotes.set(item.id, item.attendeNote || '');
        
        const isExistIndex = mergeAttendee.findIndex((u) => u.id == item.id);
        if (isExistIndex === -1) {
          mergeAttendee.push(item);
        } else {
          if (
            mergeAttendee[isExistIndex].emailList &&
            !mergeAttendee[isExistIndex].emailList.includes(item.email)
          ) {
            mergeAttendee[isExistIndex].emailList.push(item.email);
          } else {
            mergeAttendee[isExistIndex].emailList = [item.email];
          }
        }
      });
      this.$emit("onAttendedStateChanged", mergeAttendee);
      this.newAttendeesDialog = false;
      this.loading = false;
      this.attendeesData = mergeAttendee;
    },
    getAttendeesList,
  },
};

function getAttendeesList() {
  const attendeesData = _.cloneDeep(this.attendeesData);
  this.attendeesData = this.attendeesList.map((user) => {
    const attendeeUser = attendeesData.find((item) => item.id === user.id);
    const noteValue = attendeeUser?.attendeNote ?? user.attendeNote ?? '';
    
    this.originalNotes.set(user.id, noteValue);
    
    return {
      ...user,
      firstName: attendeeUser?.firstName ?? user.firstName,
      lastName: attendeeUser?.lastName ?? user.lastName,
      profilePhoto: attendeeUser?.profilePhoto ?? user.profilePhoto,
      attendeNote: noteValue,
    };
  });
}

function moveAttendee(attendee, index, direction) {
  let moveIndex = direction === "up" ? index - 1 : index + 1;

  if (moveIndex < 0 || moveIndex >= this.attendeesData.length) {
    return;
  }

  let moveOldAttendee = this.attendeesData.find(
    (f) => f.id === this.attendeesData[moveIndex].id
  );

  if (moveOldAttendee) {
    moveOldAttendee.order = index;
  }

  let moveAttendee = this.attendeesData.find((f) => f.id === attendee.id);

  if (moveAttendee) {
    moveAttendee.order = moveIndex;
  }

  const sortAttendees = this.attendeesData.sort((a, b) => a.order - b.order);

  this.$emit("onAttendedStateChanged", sortAttendees);
}
</script>

<style scoped>
.v-textarea.v-input--is-disabled .v-input__control .v-input__slot {
  background-color: #f5f5f5 !important;
  opacity: 0.7;
}

.v-textarea[readonly] .v-input__control .v-input__slot {
  background-color: #fafafa !important;
  cursor: not-allowed;
}

.v-textarea .v-text-field__slot input::placeholder {
  color: #666 !important;
  font-style: italic;
}

.v-textarea[readonly] .v-text-field__slot textarea::placeholder {
  color: #999 !important;
  font-style: italic;
}

.a-toggle-button.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn {
  border-color: var(--v-primaryDark-base) !important;
}
.a-toggle-button.disable-events.v-btn-toggle:not(.v-btn-toggle--group)
  .v-btn.v-btn {
  border-color: #cccccc !important;
}
.attendee-status /deep/ .v-btn__content {
  font-size: 13px !important;
}

.arrow-up-thick {
  border-radius: 4px 4px 0px 0px !important;
}

.arrow-down-thick {
  border-radius: 0px 0px 4px 4px !important;
}

.arrow-up-thick-left {
  border-radius: 4px 0px 0px 4px !important;
}

.arrow-down-thick-right {
  border-radius: 0px 4px 4px 0px !important;
}
</style>